// extracted by mini-css-extract-plugin
export default {"family-filter":"_VkOnFaCB9IQ5RYKm3Dy"};